import { Entity } from "../../state/entity"
import { Container } from "../../state/types";
import { EndpointRequest } from "../endpoint"

class JSONRequest implements EndpointRequest
{
    public get data(): Entity
    {
        return this._data;
    }

    public set data(data: Entity)
    {
        this._data = data;
    }

    public get headers(): Container
    {
        return {
            "Content-Type": "application/json"
        };
    }

    public get body(): Container
    {
        return this._data;
    }

    private _data: Entity;
}

const create = (entity: Entity): EndpointRequest =>
{
    let request = new JSONRequest();
    request.data = entity;
    return request;
}

export
{
    create,
    JSONRequest
}
